module.exports = __webpack_public_path__ + "static/media/countingwell-banner-3.21e53a11.png";